import { FETCH_INSTRUCTION_DATA_FAILURE, FETCH_INSTRUCTION_DATA_REQUEST, FETCH_INSTRUCTION_DATA_SUCCESS } from './actionCreator';

const initialState = {
  data: [],
  instruction: {},
  loading: false,
  error: null,
};

const systemInstructionReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_INSTRUCTION_DATA_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_INSTRUCTION_DATA_SUCCESS:
      return { ...state, loading: false, instruction: action.payload, error: null };
    case FETCH_INSTRUCTION_DATA_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default systemInstructionReducer;
